/** Prototype experienceLabel: "Under 1 year", "1+ year", "4+ years" (of experience). Takes whole years. */
export default function experienceLabel(years?: number | null): string {
  const y = Math.floor(years ?? 0);
  if (y < 1) return "Under 1 year of experience";
  return `${y}+ ${y === 1 ? "year" : "years"} of experience`;
}
